export default __webpack_public_path__ + "static/singles-case.png";